/* eslint-disable */
const REPORTFILTER_STATE = {
	reportFilters: {
        reportTypes: [],
        reportContents: []
    }
};
export default REPORTFILTER_STATE;
